import { Dictionary } from 'underscore';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IMetricDataInfo } from '../../ts/models/IMetricInfo';
import { AppState } from '../state/AppState';

const nonMetricData = {};

export function selectMetricDataFromCacheForMetricId(state: AppState, metricId: string): IMetricDataInfo {
  return state.contentExplorer.metricsDataCache[metricId];
}

export function selectMetricDataFromCacheForContentItem(state: AppState, content: (IContentInfo<ExplorableItemType> | Dictionary<any>)): IMetricDataInfo {
  if (!content || content.contentType !== 'metric') {
    return nonMetricData;
  }
  return state.contentExplorer.metricsDataCache[content.id];
}
